class LocationModel {
  lon;
  lat;

  constructor(data) {
    this.populate(data || {});
  }

  populate(data) {
    this.lon = data.lon || null;
    this.lat = data.lat || null;
  }

  get isValid() {
    return this.lon !== null && this.lat !== null;
  }

  hasChanged(data) {
    return this.lon !== data.lon || this.lat !== data.lat;
  }
}

export { LocationModel };
